import React, { Component } from 'react'
import { Div } from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'
import { getAccountProperties } from 'api/accounts'
import { omit, find, propEq, forEachObjIndexed } from 'ramda'

const DEFAULT_ACCOUNT_PROPERTIES = {
  name: 'Account Name',
  owner: 'Account Owner',
  domain: 'Domain'
}

class ImportMappingTableRows extends Component {

  state = {
    currentAccountProperties: null,
    hasChosenWrong: false,
    incorrectChoice: null
  }

  componentDidMount() {
    this.getAccountProperties()
  }

  getAccountProperties = async () => {
    try {
      const { data } = await getAccountProperties()

      this.setState({
        currentAccountProperties: data
      })
    } catch (e) {
      console.log(e)
    }
  }

  updateField = ({ value }, rowHeader) => this.setState(prevState => {
    if (!Object.values(omit(['currentAccountProperties', 'hasChosenWrong', 'incorrectChoice'], prevState)).includes(value)) {
      return {
        [rowHeader]: value,
        hasChosenWrong: false,
        incorrectChoice: null
      }
    } else {
      return {
        hasChosenWrong: !prevState.hasChosenWrong,
        incorrectChoice: value
      }
    }
  }, this.triggerChange)


  triggerChange = () => {
    const { onChange } = this.props

    const cleanedState = omit(['currentAccountProperties', 'hasChosenWrong', 'incorrectChoice'], this.state)

    const currentKeys = Object.values(cleanedState).filter(prop => this.isDefaultProperty(prop))

    const headerMap = []

    if (currentKeys.length === 3) {
      forEachObjIndexed((value, key) => {
        headerMap.push({
          name: key, // csvheader
          value: this.isDefaultProperty(value) ? `${value.toUpperCase()}` : `${value}`, //driftProperty
          type: this.determinePropertyType(value)
        })
      }, cleanedState)
    
      onChange(headerMap)
    }
    
  }

  selectRowSample = (value) => {
    const { upload } = this.props

    if (!value) return null

    return find(propEq('header', value))(upload.sampleHeader).sample
  }

  determineAccountProperty = ({ header }) => {
    return find(propEq('label', header))
  }

  isDefaultProperty = (property) => {
    return Object.keys(DEFAULT_ACCOUNT_PROPERTIES).includes(property)
  }

  determinePropertyType = (property) => {
    const { currentAccountProperties } = this.state

    if (this.isDefaultProperty(property)) {
      return 'string'
    } else {
      return find(propEq('label', property))(currentAccountProperties).type
    }
  }

  renderRows = () => {
    const { upload } = this.props
    const { currentAccountProperties, hasChosenWrong, incorrectChoice } = this.state

    const defaults = [{label: 'name', value: 'name'}, {label: 'owner', value: 'owner'}, {label: 'domain', value: 'domain'}]

    const driftProperties = defaults.concat(currentAccountProperties.map(property => ({
      label: property.label,
      value: property.label
    })))

    return upload.sampleHeader.map((row, i) => {
      return (
        <tr>
          <td>{row.header}</td>
          <td>{this.selectRowSample(this.state[row.header] ? row.header : null)}</td>
          <td className="drift-property-select-cell">
            {(!!hasChosenWrong && row.header === incorrectChoice) &&
              <Div className="incorrect-choice-warning">Sorry, but you can only select 1 instance of a Drift property per CSV upload</Div>
            }
            <Select
              menuPlacement="auto"
              options={driftProperties}
              value={find(propEq('value', this.state[row.header]), driftProperties)}
              onChange={(event) => this.updateField(event, row.header)}
            />
          </td>
        </tr>
      )
    })
  }
  
  render() {
    const { currentAccountProperties } = this.state
    return (
      <tbody>
        {!!currentAccountProperties && this.renderRows()}
      </tbody>
    )
  }
}

export default ImportMappingTableRows
